import Box from "@mui/material/Box";
import React from "react";

import { formKey } from "../../../hooks/useQuoteBoxStructure";
import {
  CardRow,
  StructureSection,
} from "../OpenBoxQuotes/BoxStructureFields";
import { NumberedSectionTitle } from "../OpenBoxQuotes/FormFields";
import { useStyles } from "../styles";
import {
  HYDRAULIC_TON,
  NoteCard,
  REAR_FRAME,
  REAR_OPENING,
  ROOF_TYPE,
  SIDE_FLAP,
  SideDoorOpeningsCard,
  ThicknessCard,
  TypeCard,
  insulatedKey,
} from "./BoxStructureCards";

const BoxStructure = () => {
  const styles = useStyles();

  return (
    <Box className={styles.inputCard}>
      <NumberedSectionTitle
        number={2}
        titleKey={formKey("SECTIONS.BOX_STRUCTURE")}
      />

      <StructureSection titleKey={insulatedKey("SECTIONS.ROOF")} plain>
        <CardRow columns={1}>
          <TypeCard
            cardKey="roofType"
            titleKey={insulatedKey("CARDS.INSULATED_ROOF_TYPE")}
            options={ROOF_TYPE}
          />
        </CardRow>
      </StructureSection>

      <StructureSection titleKey={insulatedKey("SECTIONS.FRONT_WALL_AND_FRAME")}>
        <CardRow columns={3}>
          <ThicknessCard
            cardKey="frontWall"
            titleKey={insulatedKey("CARDS.INSULATED_FRONT_WALL")}
          />
          <NoteCard
            cardKey="frontWallReinforcement"
            titleKey={insulatedKey("CARDS.FRONT_WALL_REINFORCEMENT")}
          />
          <TypeCard
            cardKey="rearFrame"
            titleKey={insulatedKey("CARDS.REAR_FRAME")}
            options={REAR_FRAME}
          />
        </CardRow>
      </StructureSection>

      <StructureSection titleKey={insulatedKey("SECTIONS.OPENINGS_AND_DOORS")}>
        <CardRow columns={2}>
          <SideDoorOpeningsCard />
          <TypeCard
            cardKey="rearOpening"
            titleKey={insulatedKey("CARDS.REAR_OPENING")}
            options={REAR_OPENING}
          />
        </CardRow>
        <CardRow columns={2}>
          <TypeCard
            cardKey="hydraulicSide"
            titleKey={insulatedKey("CARDS.HYDRAULIC_SIDE")}
            options={HYDRAULIC_TON}
            selectLabelKey={insulatedKey("FIELDS.TON")}
          />
          <TypeCard
            cardKey="sideCompletionFlap"
            titleKey={insulatedKey("CARDS.SIDE_COMPLETION_FLAP")}
            options={SIDE_FLAP}
          />
        </CardRow>
      </StructureSection>
    </Box>
  );
};

export default BoxStructure;
